// Inputs take their hint as a plain string, as the legacy passes the Sitecore value straight through.
export const hintOf = (hint: unknown): string | undefined => (typeof hint === 'string' ? hint : undefined);
